import { LazyAfterPaintBackgroundScripts } from '@atlassian/jira-dashboard-background-scripts/src/async.tsx';

export const DashboardBackgroundScripts = LazyAfterPaintBackgroundScripts;

DashboardBackgroundScripts.displayName = 'ConditionalDashboardBackgroundScripts';
